<template>
  <b-modal
    id="check-betstop-modal"
    title="NSER BETSTOP CHECK"
    hide-footer
    centered
    size="sm"
    dialog-class="check-betstop-dialog"
    content-class="check-betstop-content"
  >
    <p class="text-center text-black">
      We are going to check on this customer's betstop status.
    </p>
    <div class="text-black text-center mt-1 mb-1">
      <p>
        <span style="font-weight: 900">Name: </span
        >{{ userData.user.firstName }} {{ userData.user.middleName }}
        {{ userData.user.lastName }}
      </p>
      <p>
        <span style="font-weight: 900">Email: </span>{{ userData.user.email }}
      </p>
      <p>
        <span style="font-weight: 900">Mobile: </span
        >{{ userData.user.phoneNumber }}
      </p>
      <p>
        <span style="font-weight: 900">Postcode: </span
        >{{ userData.user.postCode }}
      </p>
    </div>

    <p
      v-if="!loadingCheckBetstop && isBetstop"
      class="text-danger text-center font-weight-bold"
    >
      This customer has appeared on the BETSTOP portal as TRUE. We will now
      block this account
    </p>
    <p
      v-if="!loadingCheckBetstop && !isBetstop"
      class="text-primary text-center font-weight-bold"
    >
      This customer has appeared on the BETSTOP portal as FALSE.
    </p>
  </b-modal>
</template>

<script>
import { BButton, BModal, BFormGroup, BFormInput } from "bootstrap-vue";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    BButton,
    BModal,
    BFormGroup,
    BFormInput,
  },
  data() {
    return {
      email: "",
    };
  },
  computed: {
    ...mapState("user/detail", ["loadingCheckBetstop", "isBetstop", "userData"]),
  },
  methods: {
    ...mapActions({
      fetchUser: "user/detail/asyncUser",
    }),
    closeModal() {
      this.$bvModal.hide("reset-password-modal");
    },
    resetPassword() {},
  },
};
</script>
